import React from 'react';
import PropTypes from 'prop-types';
import {keys} from 'lodash/object';
import {Link} from 'react-router-dom';

import {EXTERNAL_URL} from 'configs';
import {Button} from 'reactstrap';
import MuiIcon from 'components/Icons/MuiIcon';

const {DATA_TEMPLATE} = EXTERNAL_URL;

const propTypes = {
  type: PropTypes.oneOf([...keys(DATA_TEMPLATE)]).isRequired,
};

const defaultProps = {
  icon: false,
  color: 'primary',
  outline: false,
};

function ButtonDataTemplate(props) {
  const {icon, type, children, ...rest} = props;

  return (
    <Button
      tag={Link}
      to={DATA_TEMPLATE[type]}
      target="_blank"
      rel="noopener noreferrer"
      {...rest}
    >
      <MuiIcon name="insert_drive_file" size="lg" className="mr-1" />
      {children}
    </Button>
  );
}

ButtonDataTemplate.propTypes = propTypes;
ButtonDataTemplate.defaultProps = defaultProps;

export default ButtonDataTemplate;
